import React, { useEffect, useState } from "react";
import Images from "../../../Images";
import {
  CombineInputGroup,
  InputGroup,
  Label,
  SubmitBtn,
} from "../../../Components/Styles/InputStyles";
import * as Yup from "yup";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import moment from "moment";
import { useFormik } from "formik";
import tw from "tailwind-styled-components";
import { toast } from "react-toastify";


export default function GuardianDetails({
  tenantData,
  setSelectedData,
  addGuardianDetailMutate,
  isGuardianDetailLoading,
  e
}
) {
  const [data, setData] = useState(tenantData);

  const validateNoSpecialChars = (value) => {
    let error;
    if (/[^a-zA-Z0-9 ]/.test(value)) {
      error = 'Only letters, numbers, and spaces allowed.';
    }
    return error;
  };

  useEffect(() => {
    setData(tenantData);
  }, [tenantData]);

  const guardianFormik = useFormik({
    initialValues: {
      fatherName: tenantData?.fatherName || "",
      fatherMobile: tenantData?.fatherMobile || "",
      fatherOccupation: tenantData?.fatherOccupation || "",
      fatherAnnualIncome: tenantData?.fatherAnnualIncome || "",
      motherName: tenantData?.motherName || "",
      motherMobile: tenantData?.motherMobile || undefined,
      localGuardianName: tenantData?.localGuardianName || "",
      localGuardianMobile: tenantData?.localGuardianMobile || undefined,
      localGuardianRelation: tenantData?.localGuardianRelation || "",
    },
    validationSchema: Yup.object({
      fatherName: Yup.string(),
      fatherMobile: Yup.string(),
      fatherOccupation: Yup.string(),
      fatherAnnualIncome: Yup.number(),
      motherName: Yup.string(),
      //motherMobile: Yup.string(),
      localGuardianName: Yup.string(),
      //localGuardianMobile: Yup.string(),
      localGuardianRelation: Yup.string(),
    }),
    onSubmit: (values) => {
      // if (!values.fatherName) {
      //   toast.error("Father's Name is required");
      //   return;
      // }
      // if (!values.fatherMobile) {
      //   toast.error("Father's Number is required");
      //   return;
      // }
      // if (!/^\d{10}$/.test(values.fatherMobile)) {
      //   toast.error("Mobile Number must be exactly 10 digits");
      //   return;
      // }
      // if (!values.fatherOccupation) {
      //   toast.error("Father's Occupation is required");
      //   return;
      // }
      // if (!values.fatherAnnualIncome) {
      //   toast.error("Annual Income is required");
      //   return;
      // }
      // if (!values.localGuardianName) {
      //   toast.error("Local Guardian Name is required");
      //   return;
      // }
      // if (!values.localGuardianMobile) {
      //   toast.error("Guardian's Mobile is required");
      //   return;
      // }
      // if (!/^\d{10}$/.test(values.localGuardianMobile)) {
      //   toast.error("Mobile Number must be exactly 10 digits");
      //   return;
      // }
      addGuardianDetailMutate(values);
    },
    enableReinitialize: true,
  });

  const getInputClass = (isDisabled) => {
    return isDisabled
      ? "bg-gray-100 cursor-not-allowed" : "pl-2 relative rounded-md w-full flex items-center border border-gray-400 h-12";
  };

  return (
    <>
      <Wrapper>
        <Title>
          Guardian Details
        </Title>
        <form
          onSubmit={guardianFormik.handleSubmit}
          className="grid grid-cols-1  md:gap-4"
        >
          <CombineInputGroup>
            <InputGroup>
              <Label htmlFor="fatherName">Father Name</Label>
              <FieldWrapper>
                <Input
                  type="text"
                  id="fatherName"
                  name="fatherName"
                  className={getInputClass(false)}
                  validate={validateNoSpecialChars}
                  value={guardianFormik.values.fatherName}
                  //onChange={guardianFormik.handleChange}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^[a-zA-Z0-9. ]{0,50}$/.test(value)) {
                      guardianFormik.setFieldValue("fatherName", value);
                    }
                  }}
                  onBlur={guardianFormik.handleBlur}
                />
                {guardianFormik.touched.fatherName &&
                  guardianFormik.errors.fatherName && (
                    <p className="text-rose-600 text-sm">
                      {guardianFormik.errors.fatherName}
                    </p>
                  )}
              </FieldWrapper>
            </InputGroup>

            <InputGroup>
              <Label htmlFor="fatherMobile">Father Mobile</Label>
              <FieldWrapper>
                <Input
                  type="text"
                  id="fatherMobile"
                  name="fatherMobile"
                  className={getInputClass(false)}
                  value={guardianFormik.values.fatherMobile}
                  //onChange={guardianFormik.handleChange}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d{0,10}$/.test(value)) {
                      guardianFormik.setFieldValue("fatherMobile", value);
                    }
                  }}
                  onBlur={guardianFormik.handleBlur}
                  maxLength={10}
                />
                {guardianFormik.touched.fatherMobile &&
                  guardianFormik.errors.fatherMobile && (
                    <p className="text-rose-600 text-sm">
                      {guardianFormik.errors.fatherMobile}
                    </p>
                  )}
              </FieldWrapper>
            </InputGroup>
            <InputGroup>
              <Label htmlFor="fatherOccupation">Father Occupation</Label>

              <FieldWrapper>
                <Select
                  id="fatherOccupation"
                  name="fatherOccupation"
                  className="w-full pl-2"
                  value={guardianFormik.values.fatherOccupation}
                  onChange={guardianFormik.handleChange}
                  onBlur={guardianFormik.handleBlur}
                  style={{ height: "46px" }}
                >
                  <MenuItem>
                    <span className="text-gray-400">Select father occupation</span>
                  </MenuItem>
                  <MenuItem value="Self Employed">Self Employed</MenuItem>
                  <MenuItem value="Salaried">Salaried</MenuItem>
                </Select>
                {guardianFormik.touched.fatherOccupation &&
                  guardianFormik.errors.fatherOccupation && (
                    <p className="text-rose-600 text-sm">
                      {guardianFormik.errors.fatherOccupation}
                    </p>
                  )}
              </FieldWrapper>
            </InputGroup>
          </CombineInputGroup>

          <CombineInputGroup>
            <InputGroup>
              <Label htmlFor="fatherAnnualIncome">Annual Income (₹)</Label>
              <FieldWrapper>
                <Input
                  type="text"
                  id="fatherAnnualIncome"
                  name="fatherAnnualIncome"
                  className={getInputClass(false)}
                  value={guardianFormik.values.fatherAnnualIncome}
                  //onChange={guardianFormik.handleChange}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d{0,10}$/.test(value)) {
                      guardianFormik.setFieldValue("fatherAnnualIncome", value);
                    }
                  }}
                  onBlur={guardianFormik.handleBlur}
                  maxLength={7}
                />
                {guardianFormik.touched.fatherAnnualIncome &&
                  guardianFormik.errors.fatherAnnualIncome && (
                    <p className="text-rose-600 text-sm">
                      {guardianFormik.errors.fatherAnnualIncome}
                    </p>
                  )}
              </FieldWrapper>
            </InputGroup>
            <InputGroup>
              <Label htmlFor="motherName">Mother Name</Label>
              <FieldWrapper>
                <Input
                  type="text"
                  id="motherName"
                  name="motherName"
                  className={getInputClass(false)}
                  value={guardianFormik.values.motherName}
                  //onChange={guardianFormik.handleChange}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^[a-zA-Z0-9. ]{0,50}$/.test(value)) {
                      guardianFormik.setFieldValue("motherName", value);
                    }
                  }}
                  onBlur={guardianFormik.handleBlur}
                />
                {guardianFormik.touched.motherName &&
                  guardianFormik.errors.motherName && (
                    <p className="text-rose-600 text-sm">
                      {guardianFormik.errors.motherName}
                    </p>
                  )}
              </FieldWrapper>
            </InputGroup>
            <InputGroup>
              <Label htmlFor="motherMobile">Mother Mobile</Label>
              <FieldWrapper>
                <Input
                  type="text"
                  id="motherMobile"
                  name="motherMobile"
                  className={getInputClass(false)}
                  value={guardianFormik.values.motherMobile}
                  //onChange={guardianFormik.handleChange}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d{0,10}$/.test(value)) {
                      guardianFormik.setFieldValue("motherMobile", value);
                    }
                  }}
                  onBlur={guardianFormik.handleBlur}
                  maxLength={10}
                />
                {guardianFormik.touched.motherMobile &&
                  guardianFormik.errors.motherMobile && (
                    <p className="text-rose-600 text-sm">
                      {guardianFormik.errors.motherMobile}
                    </p>
                  )}
              </FieldWrapper>
            </InputGroup>
          </CombineInputGroup>

          <CombineInputGroup>
            <InputGroup>
              <Label htmlFor="localGuardianName">Local Guardian Name</Label>
              <FieldWrapper>
                <Input
                  type="text"
                  id="localGuardianName"
                  name="localGuardianName"
                  className={getInputClass(false)}
                  value={guardianFormik.values.localGuardianName}
                  //onChange={guardianFormik.handleChange}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^[a-zA-Z0-9. ]{0,50}$/.test(value)) {
                      guardianFormik.setFieldValue("localGuardianName", value);
                    }
                  }}
                  onBlur={guardianFormik.handleBlur}
                />
              </FieldWrapper>
            </InputGroup>
            <InputGroup>
              <Label htmlFor="localGuardianMobile">Guardian Mobile</Label>
              <FieldWrapper>
                <Input
                  type="text"
                  id="localGuardianMobile"
                  name="localGuardianMobile"
                  className={getInputClass(false)}
                  value={guardianFormik.values.localGuardianMobile}
                  //onChange={guardianFormik.handleChange}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d{0,10}$/.test(value)) {
                      guardianFormik.setFieldValue("localGuardianMobile", value);
                    }
                  }}
                  onBlur={guardianFormik.handleBlur}
                  maxLength={10}
                />
              </FieldWrapper>
            </InputGroup>
            <InputGroup>
              <Label htmlFor="localGuardianRelation">Relationship</Label>
              <FieldWrapper>
                <Select
                  id="localGuardianRelation"
                  name="localGuardianRelation"
                  className="w-full pl-2"
                  value={guardianFormik.values.localGuardianRelation}
                  onChange={guardianFormik.handleChange}
                  onBlur={guardianFormik.handleBlur}
                  style={{ height: "46px" }}
                >
                  <MenuItem>
                    <span className="text-gray-400">Select relationship</span>
                  </MenuItem>
                  <MenuItem value="1">Uncle</MenuItem>
                  <MenuItem value="2">Aunty</MenuItem>
                  <MenuItem value="3">Brother</MenuItem>
                  <MenuItem value="4">Sister</MenuItem>
                  <MenuItem value="5">Friend</MenuItem>
                </Select>
              </FieldWrapper>
            </InputGroup>
          </CombineInputGroup>
          <BtnWrapper>
            <SubmitBtn type="submit" disabled={e ? true : isGuardianDetailLoading} className="text-sm  w-24  md:w-20 h-7 md:text-xs">
              {isGuardianDetailLoading ? "Updating..." : "Update"}
            </SubmitBtn>
          </BtnWrapper>
        </form>
      </Wrapper>
    </>
  );
}

const Wrapper = tw.div` space-y-4 mt-2`;
const Title = tw.h3`text-md md:text-md lg:text-md tracking-wider font-semibold pb-2 text-black`;
const Input = tw.input`truncate border border-gray-300 border-m rounded pl-2 focus:ring-1 focus:ring-sky-600 focus:border-sky-600 focus:outline-none duration-200`;
const FieldWrapper = tw.div`w-full`;
const BtnWrapper = tw.div`w-full flex items-center justify-end mt-4`;
